<template>
  <div>
    <VideoTrigger>
      <slot />
    </VideoTrigger>
    <GfrDialog
      :show="open"
      transition="slide-down"
      lock-scroll
      placement="center"
      @update:show="onUpdateShow"
      @closed="onClosed"
      :closeable="true"
      :close-icon="true"
    >
      <template #closeIcon>
        <button class="app-video-popup-close">
          <IconsClose class="w-8 h-8 text-light" />
        </button>
      </template>
      <template #content>
        <div class="app-video-popup-content">
          <ClientOnly>
            <AspectRatio :ratio="16 / 9">
              <video
                v-if="!isYoutube && renderVideo"
                width="100%"
                height="100%"
                class="bg-[#2b2d32]"
                :poster="poster"
                controls
                webkit-playsinline
                playsinline
                x5-video-player-type="h5"
              >
                <source :src="url" type="video/mp4" />
              </video>
              <iframe
                v-if="isYoutube && renderVideo"
                class="h-full w-full bg-[#2b2d32]"
                :src="url"
                title=""
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </AspectRatio>
          </ClientOnly>
        </div>
      </template>
    </GfrDialog>
  </div>
</template>
<script lang="ts" setup>
import VideoTrigger from '~/components/common/VideoPopup/Trigger.vue'
import { AspectRatio } from '@/components/ui/aspect-ratio'
const open = ref(false)
const renderVideo = ref(false)
const props = defineProps({
  url: {
    type: String,
    required: true
  },
  poster: {
    type: String,
    default: ''
  }
})
const triggerOpen = () => {
  open.value = true
  renderVideo.value = true
}
const triggerClose = () => (open.value = false)

const onUpdateShow = (show: boolean) => {
  open.value = show
}
const onClosed = () => {
  renderVideo.value = false
}
const isYoutube = computed(() => props.url.includes('youtube'))
provide('trigger', triggerOpen)
</script>
<style lang="scss" scoped>
.app-video-popup-content {
  @apply w-[75rem] h-[42.125rem] max-2xl:w-[50rem] max-2xl:h-[28.125rem] max-lg:w-[23.4375rem] max-lg:h-[13.1875rem] max-lg:landscape:w-[26.25rem] max-lg:landscape:h-[14.75rem];
}
</style>
